<template>
    <LMap
        ref="map"
        style="height: 200px"
        :center="latLng"
    >
        <LTileLayer
            :url="url"
            :attribution="attribution"
        />
        <LMarker
            v-for="(marker, index) in markers"
            :key="index"
            :latLng="marker.latLng"
        >
            <LIcon
                :iconUrl="iconMarkerUrl"
                :iconSize="[32, 32]"
                :iconAnchor="[16, 32]"
            />
        </LMarker>
    </LMap>
</template>

<script>
import {LMap, LMarker, LTileLayer, LIcon} from "vue2-leaflet";

import L from "leaflet";

export default {
    components:{
        LMap,
        LTileLayer,
        LMarker,
        LIcon
    },
    props: {
        latLng: {
            type: Array,
            required: true
        },
        markers: {
            type: Array,
            default: () => []
        },
        markerIcon: {
            type: String,
            default: 'pin'
        }
    },
    data() {
        return {
            url: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
            attribution:
                '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        }
    },
    computed: {
        iconMarkerUrl() {
            switch(this.markerIcon) {
                case 'parking':
                    return require('@/assets/images/parking.png');
                default:
                    return require('@/assets/images/pin.png');
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            const minLat = Math.min(...this.markers.map(marker => marker.latLng[0]));
            const maxLat = Math.max(...this.markers.map(marker => marker.latLng[0]));
            const minLng = Math.min(...this.markers.map(marker => marker.latLng[1]));
            const maxLng = Math.max(...this.markers.map(marker => marker.latLng[1]));

            const southWestSpot = L.latLng(minLat, minLng);
            const northEastSpot = L.latLng(maxLat, maxLng);
            const bounds = L.latLngBounds(southWestSpot, northEastSpot);

            this.$refs.map.mapObject.fitBounds(bounds);
        });
    }
}
</script>

<style lang="scss">
</style>
